import { withRouter } from 'react-router';
import ModuleTabs from './ModuleTabs';

export default withRouter(ModuleTabs);
